import img1 from "../images/livros/1.webp";
import img2 from "../images/livros/2.webp";
import img3 from "../images/livros/3.webp";
import img4 from "../images/livros/4.webp";
import img5 from "../images/livros/5.webp";
import img6 from "../images/livros/6.webp";
const Livros = [
  {
    id: "1",
    title: "Alfabetização Cognitiva:",
    description:
      "As atividades desenvolvem de forma lúdica e estruturada todas as habilidades que seu filho precisa para ler e escrever com fluência: linguagem, coordenação motora fina, grafismo, memória e raciocínio lógico.",
    img: img1,
  },
  {
    id: "2",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    img: img2,
  },
  {
    id: "3",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    img: img3,
  },
  {
    id: "4",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    img: img4,
  },
  {
    id: "5",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    img: img5,
  },
  {
    id: "6",
    title: "Alfabetização Emocional:",
    description:
      "Aqui está o nosso grande segredo. Mais do que aprender a ler e escrever, seu filho vai aprender a lidar com os erros sem medo. Ele vai descobrir como transformar frustração em motivação, fortalecer a autoestima e desenvolver resiliência de forma leve — habilidades que o acompanharão por toda a vida. Com o Kit Neuroalfabetização, seu filho não aprende apenas conteúdo. Ele aprende sobre si mesmo.",
    img: img6,
  },
];
export default Livros;
